import Profit from './Profit'

export default Profit
